import React from 'react';

function KakaoShareButton({ clientUuid, clientUsername }) {
  // 1) 카카오톡 공유 실행 함수
  const shareToKakao = () => {
    if (!window.Kakao) {
      // alert('Kakao SDK not loaded');
      return;
    }
    // 카카오 SDK 초기화 여부 체크
    if (!window.Kakao.isInitialized()) {
      window.Kakao.init('faac188167b161c26238eadc69d163ca');
    }

    // 2) 카카오 메시지 보내기
    window.Kakao.Share.sendDefault({
      objectType: 'feed',   // 피드 타입 예시
      content: {
        title: '🌅 Sunrise2025에서 나만의 해돋이를 완성 중입니다!',
        description: `Sunrise2025에서 목표를 이루며 해를 높이는 중입니다.
        당신의 작은 응원이 큰 힘이 됩니다! 🌞
        📈 "${clientUsername}님의 해가 더 높이 뜨도록 함께 응원해 주세요.`,
        imageUrl: 'https://sunrisetogether2025.fly.dev/assets/SunriseBanner.png', 
        link: {
          mobileWebUrl: `https://sunrisetogether2025.fly.dev/userSun/${clientUuid}`,
          webUrl: `https://sunrisetogether2025.fly.dev/userSun/${clientUuid}`,
        },
      },
      buttons: [
        {
          title: '해 보러가기',
          link: {
            mobileWebUrl: `https://sunrisetogether2025.fly.dev/userSun/${clientUuid}`,
            webUrl: `https://sunrisetogether2025.fly.dev/userSun/${clientUuid}`,
          },
        },
      ],
    });
  };

  return (
    <button onClick={shareToKakao}className="share-button">
              <span className="emoji-button">😀</span>
              <span className="button-text">카카오톡 공유</span>
    </button>
  );
}

export default KakaoShareButton;
